// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.56 17.56"><path d="M8.78 10.19l7.07 7.07a1 1 0 101.41-1.41l-7.07-7.07 7.07-7.07A1 1 0 1015.85.29L8.78 7.36 1.71.29A1 1 0 10.29 1.71l7.07 7.07-7.07 7.07a1 1 0 001.41 1.41z"/></svg>
);

export default fn;
